import type { ReactNode } from 'react';

export const symbol_things_to_do: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M242-180v-192h-60q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h61q5-84 61-139t146-65v-174q0-12.75 8.63-21.38Q467.25-840 480-840h208q12.75 0 21.38 8.62Q718-822.75 718-810v86q0 12.75-8.62 21.37Q700.75-694 688-694H510v58q90 10 146 65t61 139h61q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-60v192h132q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-180 110-180h132Zm60 0h148v-192H302v192Zm208 0h148v-192H510v192ZM305-432h350q-5-64-54-105t-121-41q-72 0-121 41t-54 105Zm175 0Z"
		/>
	</svg>
);
